import { render, staticRenderFns } from "./MarketOrderTableVariantImage.vue?vue&type=template&id=4f54433e&"
import script from "./MarketOrderTableVariantImage.vue?vue&type=script&lang=js&"
export * from "./MarketOrderTableVariantImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports